import baseTheme from '../baseTheme';
import { glow } from '../effects';
var MuiToggleButton = {
    /* there's even more customization in the component file */
    root: {
        border: 'none',
        transition: baseTheme.transitions.create([
            'background-color',
            'border-color',
        ]),
        zIndex: 1,
        '&.Mui-selected': glow({
            backgroundColor: baseTheme.palette.secondary.main,
            color: baseTheme.palette.secondary.contrastText,
        }),
        '&:hover, &:focus:not(.Mui-selected)': {
            backgroundColor: baseTheme.palette.primary.light,
        },
        // doubling .Mui-selected for specificity
        '&.Mui-selected.Mui-selected:hover': {
            backgroundColor: baseTheme.palette.secondary.main,
            color: baseTheme.palette.secondary.contrastText,
        },
        '&.Mui-disabled': {
            zIndex: 0,
            '&.Mui-selected': {
                backgroundColor: baseTheme.palette.text.disabled,
                color: baseTheme.palette.grey[50],
            },
        },
    },
    sizeSmall: {
        height: 'auto',
        paddingLeft: baseTheme.spacing(1),
        paddingRight: baseTheme.spacing(1),
        '&:last-child': {
            paddingLeft: baseTheme.spacing(1),
        },
    },
};
export default MuiToggleButton;
//# sourceMappingURL=MuiToggleButton.js.map